export default {
	catalogUrl: "https://stac.eurac.edu",
  catalogTitle: "Eurac.STAC",
  catalogTitleAfterImage: null,
  catalogImage: null,
  allowExternalAccess: true, // Must be true if catalogUrl is not given
  allowedDomains: [],
  enforcedColorMode: "auto",
  detectLocaleFromBrowser: true,
  storeLocale: true,
  locale: "en",
  fallbackLocale: "en",
  supportedLocales: [
    "ar",
    "de",
//  "de-CH",
    "es",
    "en",
//  "en-GB",
//  "en-US",
    "fr",
//  "fr-CA",
//  "fr-CH",
    "it",
//  "it-CH",
    "ro",
    "ru",
    "ja",
    "pt",
//  "pt-BR",
    "id",
    "pl",
    "sv"
  ],
  apiCatalogPriority: null,
  useTileLayerAsFallback: false,
  displayGeoTiffByDefault: true,
  displayPreview: true,
  displayOverview: true,
  displayOverviewsForChildren: true,
  maxDisplayPixels: null,
  buildTileUrlTemplate: null,
  getMapSourceOptions: null,
  getStacLayerOptions: null,
  pathPrefix: "/",
  historyMode: "history",
  cardViewMode: "cards",
  showFavorites: true,
  defaultCollectionSort: "title",
  defaultItemSort: null,
  showKeywordsInItemCards: false,
  showKeywordsInCatalogCards: false,
  preferredAssets: true,
  showThumbnailsAsAssets: false,
  searchResultsPerPage: null,
  itemsPerPage: null,
  collectionsPerPage: null,
  maxEntriesPerPage: 1000,
  defaultThumbnailSize: null,
  crossOriginMedia: null,
  requestHeaders: {},
  requestQueryParameters: {},
  socialSharing: ['email', 'bsky', 'mastodon', 'x'],
  preprocessSTAC: null,
  authConfig: null,
  transactions: 'auto',
  transactionsRequireLogin: true,
  transactionsRequirePreflight: true,
  crs: {},
  footerLinks: null
};
